import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const ITAndCommunicationsPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  itSupportContact,
  securityOfficerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "IT_and_Communications_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">IT and Communications Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        {clientName || "The Company"} is committed to providing secure, reliable, and effective IT and communication systems to support its business operations while protecting data and ensuring compliance with relevant laws and best practices.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all employees, contractors, and third parties who access or use company IT resources, including hardware, software, networks, and communication systems.
      </p>

      <h4 className="section-title">3. Acceptable Use</h4>
      <ul>
        <li>IT resources are provided for business purposes; limited personal use is permitted provided it does not interfere with work or breach policy.</li>
        <li>Users must not engage in activities that are illegal, offensive, or harmful to the company’s reputation.</li>
        <li>Passwords and access credentials must be kept confidential and not shared.</li>
      </ul>

      <h4 className="section-title">4. Data Security</h4>
      <ul>
        <li>All company data must be stored securely with appropriate backups.</li>
        <li>Personal data must be processed in accordance with data protection laws (e.g., GDPR).</li>
        <li>Users must report any data breaches, suspicious activity, or lost devices immediately.</li>
      </ul>

      <h4 className="section-title">5. Monitoring and Privacy</h4>
      <p className="section-content">
        The company reserves the right to monitor IT usage to ensure compliance with this policy, protect systems, and maintain business standards, subject to applicable privacy laws.
      </p>

      <h4 className="section-title">6. Software and Hardware Management</h4>
      <ul>
        <li>Only authorised software may be installed on company devices.</li>
        <li>Hardware must be maintained and used responsibly.</li>
        <li>Employees must not attempt to bypass security controls or install unauthorized software.</li>
      </ul>

      <h4 className="section-title">7. Email and Communications</h4>
      <ul>
        <li>Company email accounts must be used responsibly and professionally.</li>
        <li>Spam, phishing, or fraudulent communications are prohibited.</li>
        <li>Confidential information must not be shared without proper authorisation.</li>
      </ul>

      <h4 className="section-title">8. Remote Access and Mobile Devices</h4>
      <p className="section-content">
        Remote access to company systems must be secured using approved methods (e.g., VPN). Mobile devices must have appropriate security controls such as encryption and password protection.
      </p>

      <h4 className="section-title">9. Responsibilities</h4>
      <p className="section-content"><strong>Employees:</strong> Must follow this policy and report IT security concerns promptly.</p>
      <p className="policy-details"><strong>IT Support Contact:</strong> {itSupportContact || "[Insert Contact Number]"}</p>
      <p className="policy-content"><strong>Security Officer:</strong> Oversees IT security compliance. Contact: {securityOfficerContact || "[Insert Contact Number]"}</p>

      <h4 className="section-title">10. Policy Review</h4>
      <p className="section-content">
        This policy will be reviewed annually or in response to significant IT or security incidents or legislative changes.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I acknowledge that I have read, understood, and will comply with the IT and Communications Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default ITAndCommunicationsPolicy;
